/* VIVID — seamless announcement marquee.
   Repeats the announcement text just enough to fill the bar, then duplicates it
   for a gap-free loop. Speed is px/sec so it looks consistent at any word count.
   Measures AFTER web fonts load (and on window load) so the bar is never under-filled. */
(function () {
  function build(track) {
    var container = track.closest('.announcement-marquee');
    if (!container) return;

    // Keep the original single set so resizes / re-runs recompute cleanly.
    if (!track.dataset.orig) track.dataset.orig = track.innerHTML;
    track.style.animationDuration = '';
    track.innerHTML = track.dataset.orig;

    var barWidth = container.clientWidth;
    // Layout not ready yet (hidden header, 0 width) — try again next frame.
    if (!barWidth) {
      requestAnimationFrame(function () { build(track); });
      return;
    }

    var speed = parseFloat(track.dataset.speed) || 70; // px per second

    // Repeat the set until one "unit" comfortably covers the whole bar.
    var guard = 0;
    while (track.scrollWidth < barWidth && guard < 80) {
      track.insertAdjacentHTML('beforeend', track.dataset.orig);
      guard++;
    }

    var unitWidth = track.scrollWidth; // width of one gap-free unit (>= bar width)
    // Duplicate the whole unit so translateX(-50%) loops with no gap.
    track.insertAdjacentHTML('beforeend', track.innerHTML);
    track.style.animationDuration = (unitWidth / speed).toFixed(2) + 's';
  }

  function initAll(root) {
    (root || document).querySelectorAll('.announcement-marquee__track').forEach(build);
  }

  function start() {
    initAll();
    // Re-measure once fonts are ready — Archivo widens the text after first paint.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { initAll(); });
    }
  }

  if (document.readyState !== 'loading') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }

  // Final safety pass once everything (fonts, images) has loaded.
  window.addEventListener('load', function () { initAll(); });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { initAll(); }, 200);
  });

  // Re-init when the section is edited/reloaded in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
